"use strict";

PF.Field.MapPolyline = class MapPolyline extends PF.Field
	{

	static get options()
		{

		return {
			html: PF.Field.MapPoint.templates,
			popupConfig: {
				title: 'Установите ломаную'
			},
			// mapDefault: {
			// 	lat: 55.73397910012475,
			// 	lng: 37.64455373793694,
			// 	zoom: 11
			// },
			mapDefault: {
				lat: 56.49194588506882,
				lng: 84.98186895841935,
				zoom: 12
			},
			polylineOptions: {
				strokeColor: "#00000088",
				strokeWidth: 4,
				editorMenuManager: function (items) {
					items.push({
						title: "Удалить линию",
						onClick: function () {
							this.geoObjects.remove(this.polyline);
						}
					});
					return items;
				}
			},

			label: "Ломаная",
			calcTitle: (isSet, line) => isSet ? `Ломаная установлен` : '&nbsp;',
			model: new PF.Model({}),
			key: 'polyline',

			showInfo: true,
			helper: '',

			errors: {}
		};
		}


	static get templates()
		{
		return {
			//language=HTML
			wrapper: `
				<div class="pf-select-wrapper">
					<div class="pf-select" pf="select">
						<div class="pf-select-label" pf="label"></div>
						<div class="pf-selected" pf="selected">
							<div class="item-inner">
								<div class="item-title" pf="title">
								</div>
							</div>
						</div>
					</div>
					<div class="underline">
						<hr class="normal"/>
						<hr class="focus"/>
					</div>
					<div class="info" pf="info">&nbsp;</div>
				</div>
			`,
			//language=HTML
			popupContent: `
				<div class="" pf="map" style="width:100%; height:calc(100% - 67px)">
				</div>
				<!--<form class="block row" pf="form" style="margin: 0">-->
				<!--<div class="col-33">-->
				<!--<input type="text" pf="lat"\>-->
				<!--</div>-->
				<!--<div class="col-33">-->
				<!--<input type="text" pf="lng"\>-->
				<!--</div>-->
				<!--<div class="col-33">-->
				<!--<input type="text" pf="zoom"\>-->
				<!--</div>-->
				<!--</form>-->
			`,
		};
		}


	init()
		{
		this.dom.loads(this.html);
		this.dom.element.append(this.dom.wrapper);


		this.popup = new PF.F7Popup({
			dom: {content: this.dom.popupContent},
			...this.popupConfig
		});
		this.popup.on('opened', () => {
			if (this.map === undefined)
				{
				this.initMap();
				}
		});

		this.dom.select.on('click', () => this.popup.open());

		this.calc('isSet', [
				{object: this.model, key: this.key},
			],
			(l) => l !== null && l !== undefined);

		// this.form = new PF.Form({
		// 	dom: {element: this.dom.form},
		// 	model: this.model,
		// 	fieldsConfig: {
		// 		lat: {
		// 			index: this.keyLat,
		// 			class: PF.Field.Float,
		// 			required: true,
		// 			label: 'Широта'
		// 		},
		// 		lng: {
		// 			index: this.keyLng,
		// 			class: PF.Field.Float,
		// 			required: true,
		// 			label: 'Долгота'
		// 		},
		// 		zoom: {
		// 			index: this.keyZoom,
		// 			class: PF.Field.Int,
		// 			required: true,
		// 			label: 'Масштаб карты'
		// 		},
		// 	}
		// });


		// ymaps.ready(this.initMap.bind(this));

		this.calc('errorState', 'error', (error) => error.length > 0);
		this.calc('info', ['helper', 'error'], (helper, error) => error.length > 0 ? error : helper.length > 0 ? helper : '&nbsp;');

		this.bindNode('showInfo', this.dom.info, MK.binders.display());
		this.bindNode('errorState', this.dom.element, MK.binders.className('error'));
		this.bindNode('popup.opened', this.dom.wrapper, MK.binders.className('focus'));
		this.bindNode('info', this.dom.info, MK.binders.html());
		this.bindNode('label', this.dom.label, MK.binders.html());
		this.bindNode('isSet', this.dom.select, MK.binders.className('active'));

		this.calc('title', ['isSet', 'model.key'], (isSet, line) => this.calcTitle(isSet, line));
		this.bindNode('title', this.dom.title, MK.binders.html());


		}

	reviewValue()
		{
		let valueModel = this.model.get(this.key, new PF.Model({raw: null}), new PF.Model({raw: null}));
		if (valueModel.isNull() === true || this.group.selected === null)
			{
			this.dom.selected.html('&nbsp;');
			this.dom.select.removeClass('active');
			}
		else
			{
			this.dom.selected.html(this.group.selected.itemInner);
			MK.parseBindings(this.group.selected, this.dom.selected);
			this.dom.select.addClass('active');
			}
		this.popup.close();
		}


	initMap()
		{
		if (this.isSet)
			{
			this.map = new ymaps.Map(this.dom.map[0], {center: [this.mapDefault.lat, this.mapDefault.lng], zoom: this.mapDefault.zoom, ...app.mapConfig});
			this.createPolyline(this.getCordsFromModel());
			}
		else
			{
			this.map = new ymaps.Map(this.dom.map[0], {center: [this.mapDefault.lat, this.mapDefault.lng], zoom: this.mapDefault.zoom, ...app.mapConfig});
			}

		let handler1 = (event) => {
			if (this.isSet === false)
				{
				this.point1 = event.get('coords');
				this.map.events.remove('click', handler1);
				this.map.events.add('click', handler2);
				}
		};
		let handler2 = (event) => {
			let point2 = event.get('coords');
			this.createPolyline([this.point1, point2]);
			this.map.events.remove('click', handler2);
			this.map.events.add('click', handler1);
		};

		this.map.events.add('click', handler1);
		}

	getCordsFromModel()
		{
		let cords = this.model.get(this.key).toJSON();
		let result = [];
		for (let i = 0; i < cords.length; i++)
			{
			result.push([cords[i][0], cords[i][1],]);
			}
		return result;
		}

	createPolyline(coords)
		{
		this.polyline = new ymaps.Polyline(coords, {}, {
			...this.polylineOptions
		});
		this.map.geoObjects.add(this.polyline);
		this.polyline.editor.startEditing();

		this.model.set(this.key, this.polyline.geometry.getCoordinates());
		this.polyline.events.add('geometrychange', (event) => {
			this.model.set(this.key, this.polyline.geometry.getCoordinates());
			console.log(this.polyline.geometry.getCoordinates());
		});
		}

	// setMarkerCords()
	// 	{
	// 	if (this.isSet)
	// 		{
	// 		if (this.marker !== undefined)
	// 			{
	// 			this.marker.geometry.setCoordinates([this.model[this.keyLat], this.model[this.keyLng]]);
	// 			this.map.setZoom(this.model[this.keyZoom]);
	// 			this.map.panTo([this.model[this.keyLat], this.model[this.keyLng]]);
	// 			}
	// 		}
	// 	}


	};
